/**
 * .
 * Created by jlado on 13/9/16.
 */
export class ActionTrigger {

    id: string;
    description: string;

    constructor(other ?: ActionTrigger) {
        if (other) {
            this.id = other.id;
            this.description = other.description;
        }
    }

    toString() {
        return this.description;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/actionTrigger.ts
 **/